import React, {
  forwardRef,
  ComponentType,
  FC
} from 'react';

import hoistNonReactStatics from 'hoist-non-react-statics';
import { Subtract } from 'utility-types';
import kebabCase from 'lodash/kebabCase';

export type DataElementPageLocation = 'topNav' | 'siteNav' | 'blogNav' | 'hero' | 'body' | 'topFooter' | 'bottomFooter';

export interface WithDecoratedProps {
  /** The component element page location that gets added to data-element-page-location. */
  dataElementPageLocation?: DataElementPageLocation;
  /** The component element type that gets added to data-element-type. */
  dataElementType?: string;
}

const getDisplayName = <T, >(Component: ComponentType<T>): string => {
  const componentName = Component.displayName || Component.name || 'Decorate';
  const formattedComponentName = componentName.replace('Component', '');
  return formattedComponentName;
};

const decorate = <P, S = {}>(
  Component: ComponentType<Subtract<P, WithDecoratedProps>>
): FC<P & WithDecoratedProps> & S => {
  const WithDecoratedComponent = forwardRef<HTMLElement, P & WithDecoratedProps>((
    {
      dataElementPageLocation = 'body',
      dataElementType,
      ...rest
    },
    forwardedRef
  ) => (
    <Component
      ref={forwardedRef}
      {...rest}
      data-element-page-location={dataElementPageLocation}
      data-element-type={kebabCase(dataElementType || getDisplayName(Component))}
    />
  ));

  WithDecoratedComponent.displayName = getDisplayName(Component);
  // FIXME: figure out correct return types
  // @ts-ignore
  return hoistNonReactStatics(WithDecoratedComponent, Component);
};

export { decorate };
export default decorate;
